angular.module("digitalLeasing.module").component("settingProductsRange", {
    templateUrl: "ng/components/digitalLeasing/settingProductsRange/settingProductsRange.view.html",
    bindings: {
        model: "=", //leasingData
        validatePage: "&",
        invalidatePage: "&"
    },
    controllerAs: "settingProductsRangeCtrl",
    controller: SettingProductsRangeController
});

function SettingProductsRangeController() {
    var self = this;

    self.$onInit = function () {
        jQuery(".alb-scroll.recovery-scroll").mCustomScrollbar("scrollTo", 0); //posiziona la scollBar in top ad ogni cambio vista
    };

    self.validateSettingProductsRange = function () {
      var check = self.checkRange;
  
      if (check) {
        self.validatePage();
      } else {
        self.invalidatePage();
      }
    }

    self.rangeIsOk = function(){
      self.checkRange = true;
      self.validateSettingProductsRange();
    }

    self.rangeIsNotOk = function(){
      self.checkRange = false;
      self.validateSettingProductsRange();
    }

    var handlechange = function (property, value) {
        self.model.preventivo.richiestaConvenzionePlafond[property] = value;
        console.log("setting products range: ", self.model);
      };
    
      self.handleStructureChange = function (prodottiConvenzione) {
        handlechange("prodottiConvenzione", prodottiConvenzione);
      };
}